import { ApolloClient, ApolloQueryResult, NormalizedCacheObject } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import * as Types from '@99designs/graph-utils/types';
import { InspirationDocument, InspirationQuery } from '../graphql/ProductDetails.generated';
import type { Design } from '@99designs/feature-design-inspiration';
import type { DiscoverDesignsInput } from '@99designs/graph-utils/types';

export interface ProductDetailsInspirationQuery extends DiscoverDesignsInput {
    pageSize: never;
    page: never;
}

export async function getDesignInspiration(
    client: ApolloClient<NormalizedCacheObject>,
    query: ProductDetailsInspirationQuery
): Promise<Design[] | null> {
    const inputQuery = { ...query, pageSize: 10, page: 1 };
    const { data, error } = await fetchDesignInspirationOfProductGroup(client, inputQuery);

    if (error) {
        Bugsnag.notify(error);
        return null;
    }

    if (!data || !data.discoverDesigns.designs) {
        Bugsnag.notify(new Error('Feature Product details - designs not found'), (event) => {
            event.context = `designs not found for ${JSON.stringify(inputQuery)}`;
        });
        return null;
    }

    if (!data.discoverDesigns.designs.length) {
        Bugsnag.notify(new Error('Feature Product details - empty list of designs'), (event) => {
            event.context = `designs empty for ${JSON.stringify(inputQuery)}`;
        });
    }

    return data.discoverDesigns.designs;
}

function fetchDesignInspirationOfProductGroup(
    client: ApolloClient<NormalizedCacheObject>,
    inputQuery: Types.ProductsInput
): Promise<ApolloQueryResult<InspirationQuery>> {
    return client.query({
        query: InspirationDocument,
        variables: {
            input: inputQuery,
        },
    });
}
